import moment from "moment";
import { baseUrl } from "../apiActions/dashboardApi";
// function to split number by comma for each 3 digits
export const formatNumber = (num) => {
  return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const extract_time = () => {
  const fullyear = moment().format("MM-DD-YYYY");
  const hour = moment().format("HH");
  const minutes = moment().format("mm");
  const seconds = moment().format("ss");
  const strDate = fullyear.replace("-", "")
  const finalDate = strDate.replace("-", "");
  return `${finalDate}_${hour}${minutes}${seconds}`;
}

export const fetchAccountData = (id, setter,user) => {
  const url = `${baseUrl}/accounts/${id}`;
  fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + user.access_token,
      Accept: "application/json",
      "Content-Type": "application/json",
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      setter(res)
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetchHouseData = (id, setter,user) => {
  const url = `${baseUrl}/houses/${id}`;
  fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + user.access_token,
      Accept: "application/json",
      "Content-Type": "application/json",
    }),
  })
    .then((res) => res.json())
    .then((res) => {
      setter(res);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#124db1",
      color: 'red'
      // display: "flex",
      // justifyContent: "end",
      // textAlign: "right",
    },
    cells: {
      style: {
        textAlign: "right", // Align cell content to the right
      },
    },
  },
};
export function splitStringByKeyword(inputString, keyword) {
  const index = inputString.indexOf(keyword);

  if (index !== -1) {
    const before = inputString.substring(0, index + keyword.length);
    const after = inputString.substring(index + keyword.length).trim();

    return { before, after };
  } else {
    // Handle the case when the keyword is not found
    return { before: inputString, after: "" };
  }
}
export const splitString = (str) => {
    if (str.length > 24) {
      const firstPart = str.substring(0, 24);
      const secondPart = str.substring(24);
      const shouldAppendDash = str.length > 24 && str[24] !==" ";
      const firstPartWithDash = shouldAppendDash ? `${firstPart}-` : firstPart;
      return [firstPartWithDash, secondPart];
    }
    return [str, ""];
  };
